import { CommonModule } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-quote-action-notification',
  standalone: true,
  imports: [CommonModule, NzButtonModule, NzIconModule],
  templateUrl: './quote-action-notification.component.html'
})
export class QuoteActionNotificationComponent implements OnInit {
  @ViewChild('notificationTemplate', { static: true })
  notificationTemplate: TemplateRef<{}>;

  constructor(private notification: NotificationService) { }

  ngOnInit(): void {
    this.notification.registerQuoteActionTemplate(this.notificationTemplate);
  }
}
